import WasmController from "react-lib/frameworks/WasmController";
import { State as MainState } from "react-lib/apps/segment/SegmentInterface";

// APIs
import MeHealthPackageListView from "issara-sdk/apis/MeHealthPackageListView_apps_MEH";

import * as PRXI from "HIS/Interface/PRXI";
import CONFIG from "config/config";
import OfficialAccountDivisionDetail from "issara-sdk/apis/OfficialAccountDivisionDetail_apps_PRXM";
import MeHealthPackageAddToCartView from "issara-sdk/apis/MeHealthPackageAddToCartView_apps_MEH";
import MeHealthInvoiceItemListView from "issara-sdk/apis/MeHealthInvoiceItemListView_apps_MEH";
import MeHealthInvoiceItemDetailView from "issara-sdk/apis/MeHealthInvoiceItemDetailView_apps_MEH";
import MeHealthPaymentMethodListView from "issara-sdk/apis/MeHealthPaymentMethodListView_apps_MEH";
import MeHealthInvoiceCreateView from "issara-sdk/apis/MeHealthInvoiceCreateView_apps_MEH";
import PaymentStatusChecker from "./PaymentStatusChecker";
import MeHealthReceiptCreateView from "issara-sdk/apis/MeHealthReceiptCreateView_apps_MEH";
import MeHealthInvoiceDetailView from "issara-sdk/apis/MeHealthInvoiceDetailView_apps_MEH";
import MeHealthCreditWalletLatestDetailView from "issara-sdk/apis/MeHealthCreditWalletLatestDetailView_apps_MEH";
import MeHealthCreditWalletTransactionListView from "issara-sdk/apis/MeHealthCreditWalletTransactionListView_apps_MEH";
import MeHealthInvoicePaymentTokenView from "issara-sdk/apis/MeHealthInvoicePaymentTokenView_apps_MEH";
import DivisionPaymentInfoListView from "issara-sdk/apis/DivisionPaymentInfoListView_apps_MEH";
import FormPackageReceipt from "../pdfForm/FormPackageReceipt";
import getPdfMake from "react-lib/appcon/common/pdfMake";
import moment from "moment";
import { ADMIN_NAME_LIST } from "react-lib/apps/USER/CardSettingDivision";

import jwt_encode from "jwt-encode";
import { jwtDecode } from "jwt-decode";
import { logEvent } from "firebase/analytics";

export const PROMPT_PAY_TYPE = "QR";
export const CARD_TYPE = "CC";
export const IMBANK_TYPE = "IMBANK";

export type State = {
  BillingCreditWallet: any;
  BillingCarts: any;
  BillingInvoices: any;
  BillingAndPackageSequence: {
    sequenceIndex?: string | null;
    divisionProfile: any;
    meHealthPackageList: any;
    addToCardLoading: boolean;
    openTransactionModal: boolean;
    openPaidTypePackageModal: boolean;
    openPaidResultModal: boolean;
    open2C2PPaymentModal: boolean;
    transactions: {
      formData: {
        email: string;
        address: string;
        taxId: string;
      };
      prepareInvoice: any;
      paidResult: any;
    };
    paymentMethods: any;
    paymentCheckerPolling: any;
    paymentHistory: any;
    paymentHistoryLoading: boolean;
    creditUsageList: any;
    creditUsageLoading: boolean;
    isBroadcast?: boolean;
  } | null;
};

export const StateInitial: State = {
  BillingCreditWallet: null,
  BillingCarts: null,
  BillingInvoices: null,
  BillingAndPackageSequence: {
    sequenceIndex: null,
    divisionProfile: {},
    meHealthPackageList: {},
    addToCardLoading: false,
    openTransactionModal: false,
    openPaidTypePackageModal: false,
    open2C2PPaymentModal: false,
    transactions: {
      formData: {
        email: "",
        address: "",
        taxId: "",
      },
      prepareInvoice: null,
      paidResult: null,
    },
    paymentMethods: null,
    paymentCheckerPolling: null,
    paymentHistory: null,
    paymentHistoryLoading: false,
    creditUsageList: null,
    creditUsageLoading: false,
    isBroadcast: false,
  },
};

export type Props = {};

export type Event =
  | { message: "RunSequence"; params: {} }
  | { message: "GetMasterData"; params: {} };

export type Data = {
  division?: number;
};

type Picked = Partial<
  Pick<MainState, "handleEvent" | "errorMessage" | "successMessage" | "masterOptions" | "userProfile">
>;

export const DataInitial = {};

type Handler<P = any, R = any> = (
  controller: WasmController<State & Picked, Event, Data, Props>,
  params: P
) => R;

export const Start: Handler = async (controller, params) => {
  let divisionProfile = {};
  let meHealthPackageList = {};
  let carts = {};
  let invoices = {};

  try {
    divisionProfile = await GetDivisionProfile(controller, params);

    const [packages, cart, invoice] = await Promise.all([
      GetPackageList(controller, params),
      GetCartList(controller, params),
      GetInvoiceList(controller, params),
    ]);

    console.log("cart: ", cart);

    // console.log("res: ", res);
    console.log("packages: ", packages);

    if (packages) {
      meHealthPackageList = packages;
      console.log("meHealthPackageList: ", meHealthPackageList);
    }

    if (cart) {
      carts = cart;
    }

    if (invoice) {
      invoices = invoice;
    }

  } catch (error) {
    console.error("Error fetching division profile:", error);
  }

  controller.setState({
    BillingCarts: carts,
    BillingInvoices: invoices,
    BillingAndPackageSequence: {
      sequenceIndex: "Action",
      divisionProfile,
      meHealthPackageList,
    },
  });
};

export const Action: Handler = async (controller, params) => {
  switch (params.action) {
    case "ADD_TO_CART":
      return AddToCard(controller, params);
    case "PAID":
      return PaidPackage(controller, params);
    case "CREATE_INVOICE":
      return CreateInvoice(controller, params);
    case "USE_EXISTING_INVOICE":
      return UseExistingInvoice(controller, params);
    case "BACK_TRANSACTION_SUMMARY":
      return BackToTransactionSummary(controller, params);
    case "GET_PAID_CHOICE":
      return GetPaidChoice(controller, params);
    case "2C2P_SELECTED":
      return Select2C2P(controller, params);
    case "START_PERIODIC_PAYMENT_CHECK":
      return PeriodicCheck(controller, params);
    case "GO_TO_BILLING_PACKAGE":
      return GoToBillingPackage(controller, params);
    case "DOWNLOAD_RECEIPT":
      return HandlePackageReceiptFile(controller, params);
    case "GET_RECEIPT_LIST":
      return GetReceiptList(controller, params);
    case "GET_CREDIT_USAGE_LIST":
      return GetCreditUsageList(controller, params);
    case "GET_CREDIT_WALLET":
      return GetCreditWallet(controller, params);
    case "EDIT_QTY_CARTS":
      return EditQuantityCarts(controller, params);
    case "REMOVE_PACKAGE_CARTS":
      return RemovePackageCarts(controller, params);
    case "2C2P_SUCCESS":
      return SuccessPaid2C2P(controller, params);
    case "2C2P_FAILED":
      return FailedPaid2C2P(controller, params);
    case "2C2P_CANCELED":
      return CanceledPaid2C2P(controller, params);
    case "2C2P_UNKNOWN":
      return UnknownPaid2C2P(controller, params);
    case "CLOSE_PAID_TYPE_PACKAGE":
      return ClosePaidTypePackage(controller, params);
    case "CLOSE_PAID_RESULT":
      return ClosePaidResult(controller, params);
    default:
      break;
  }
};


const ClosePaidResult: Handler = async (controller, params) => {
  controller.setState((prevState) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        openPaidTypePackageModal: false,
        openPaidResultModal: false,
        transactions: {
          ...prevState.BillingAndPackageSequence?.transactions,
          paidResult: {},
        },
      },
    };
  });
};

const ClosePaidTypePackage: Handler = async (controller, params) => {
  let state = controller.getState();
  console.log(
    "state.BillingAndPackageSequence?.paymentCheckerPolling?.stop: ",
    state.BillingAndPackageSequence?.paymentCheckerPolling?.stop
  );
  if (!!state.BillingAndPackageSequence?.paymentCheckerPolling?.stop) {
    state.BillingAndPackageSequence?.paymentCheckerPolling?.stop();
  }

  UpdateCarts(controller, params);
  GetCreditWallet(controller, params);
  controller.setState((prevState) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        openPaidTypePackageModal: false,
        paymentCheckerPolling: null,
        //TODO: need change to other location
        transactions: {
          ...prevState.BillingAndPackageSequence?.transactions,
          prepareInvoice: null,
          paidResult: null
        },
      },
    };
  });
};

const UnknownPaid2C2P: Handler = async (controller, params) => {

  let state = controller.getState();
  console.log(
    "state.BillingAndPackageSequence?.paymentCheckerPolling?.stop: ",
    state.BillingAndPackageSequence?.paymentCheckerPolling?.stop
  );
  if (!!state.BillingAndPackageSequence?.paymentCheckerPolling?.stop) {
    state.BillingAndPackageSequence?.paymentCheckerPolling?.stop();
  }
  
  GetCreditWallet(controller, params);
  UpdateCarts(controller, params);
  state = controller.getState();
  let [data, err, network] = await MeHealthInvoiceDetailView.retrieve({
    pk: state.BillingAndPackageSequence?.transactions?.prepareInvoice?.id,
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
  });

  controller.setState(
    (prevState) => {
      console.log("prevState: ", prevState);
      return {
        BillingAndPackageSequence: {
          ...prevState.BillingAndPackageSequence,
          transactions: {
            ...prevState.BillingAndPackageSequence.transactions,
            prepareInvoice: {},
            ...(data && { paidResult: data }),
          },
          paymentCheckerPolling: null,
          webPaymentUrl: "",
          paymentChannel: "",
          openPaidTypePackageModal: false,
          open2C2PPaymentModal: false,
          openPaidResultModal: true,
        },
      };
    }
  );
  
}

const FailedPaid2C2P: Handler = async (controller, params) => {

  GetCreditWallet(controller, params);
  UpdateCarts(controller, params);
  UpdateInvoices(controller, params);
  let state = controller.getState();

  let [data, err, network] = await MeHealthInvoiceDetailView.retrieve({
    pk: state.BillingAndPackageSequence?.transactions?.prepareInvoice?.id,
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
  });

  controller.setState(
    (prevState) => {
      console.log("prevState: ", prevState);
      return {
        BillingAndPackageSequence: {
          ...prevState.BillingAndPackageSequence,
          transactions: {
            ...prevState.BillingAndPackageSequence.transactions,
            prepareInvoice: null,
            ...(data && { paidResult: data }),
          },
          paymentCheckerPolling: null,
          webPaymentUrl: "",
          paymentChannel: "",
          openPaidTypePackageModal: false,
          open2C2PPaymentModal: false,
          openPaidResultModal: true,
        },
      };
    }
  );
    
  
};

const CanceledPaid2C2P: Handler = async (controller, params) => {
  let state = controller.getState();

  const invoiceId = state.BillingAndPackageSequence?.transactions?.prepareInvoice?.id;

  let [data, err, network] = await MeHealthInvoiceDetailView.retrieve({
    pk: invoiceId,
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
  });

  // redirect Item
  let [cartItemsResp, cartItemsErr] = await MeHealthInvoiceItemListView.list({
    apiToken: controller.apiToken,
    params: {
      active_flag: "ACTIVE",
      invoice: invoiceId,
    },
    extra: { division: controller.data.division || 0 }
  });

  UpdateInvoices(controller, params);

  controller.setState(
    (prevState) => {
      console.log("prevState: ", prevState);
      return {
        BillingAndPackageSequence: {
          ...prevState.BillingAndPackageSequence,
          transactions: {
            ...prevState.BillingAndPackageSequence.transactions,
            ...(data && { prepareInvoice: data }), // เปลี่ยนจาก paidResult -> prepareInvoice
          },
          paymentCheckerPolling: null,
          webPaymentUrl: "",
          paymentChannel: "",
          openPaidTypePackageModal: false,
          open2C2PPaymentModal: false,
          openPaidResultModal: false,
          openTransactionModal: true,
        },
        BillingCarts: cartItemsResp
      };
    }
  );
};

const SuccessPaid2C2P: Handler = async (controller, params) => {
  
  GetCreditWallet(controller, params);
  UpdateCarts(controller, params);
  UpdateInvoices(controller, params);
  let state = controller.getState();

  let [data, err, network] = await MeHealthInvoiceDetailView.retrieve({
    pk: state.BillingAndPackageSequence?.transactions?.prepareInvoice?.id,
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
  });

  controller.setState((prevState) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        transactions: {
          ...prevState.BillingAndPackageSequence.transactions,
          prepareInvoice: null,
          paidResult: data,
        },
        paymentCheckerPolling: null,
        webPaymentUrl: "",
        paymentChannel: "",
        openPaidTypePackageModal: false,
        openPaidResultModal: true,
        open2C2PPaymentModal: false,
      },
    };
  });
};

const GetDivisionProfile: Handler = async (controller, params) => {
  const [res] = await OfficialAccountDivisionDetail.retrieve({
    params: {},
    extra: { division: controller.data.division || 0 },
    apiToken: controller.apiToken,
  });

  let divisionProfile = {};
  if (res) {
    divisionProfile = {
      ...res,
      account_link: res.token
        ? `${CONFIG.OFFICIAL_ACCOUNT_HOST || "https://ishealth.app"}/OA/${
            res.id
          }/?openExternalBrowser=1`
        : "",
      division_address: {
        city: res.city?.id,
        district: res.district?.id,
        province: res.province?.id,
        full_address_text: res.address_text,
        zipcode: res.city?.zipcode,
        place_id: res.place_id,
        latitude: res.latitude,
        longitude: res.longitude,
      },
      division_name: res.division_name,
      hospital_name: res.hospital_name,
      image_file: res.image_file,
      address_text: res.address_text,
      tax_id: res?.tax_id,
    };
  }

  return divisionProfile;
};
const RemovePackageCarts: Handler = async (controller, params) => {
  let { BillingCarts } = controller.getState();
  let item = (BillingCarts?.items || []).find((i: any) => i.id === params.id);
  if (item) {
    let [res, err, network] = await MeHealthInvoiceItemDetailView.delete({
      pk: params.id,
      apiToken: controller.apiToken,
      extra: { division: controller.data.division || 0 },
    });

    if (err) {
      console.warn("cannot set qty");
      controller.setState({
        errorMessage: {
          BillingAndPackage: err,
        },
      });
    }
    if (network.status === 204) {
      const inCart = await GetCartList(controller, params);
      controller.setState({ BillingCarts: inCart });
    }
  }
};

const EditQuantityCarts: Handler = async (controller, params) => {
  let { BillingCarts } = controller.getState();
  let item = (BillingCarts?.items || []).find((i: any) => i.id === params.id);
  if (item) {
    let qty = Math.max(0, Number(item.quantity) + params.delta);

    let [res, err] = await MeHealthInvoiceItemDetailView.update({
      pk: params.id,
      data: { quantity: qty },
      apiToken: controller.apiToken,
      extra: { division: controller.data.division || 0 },
    });

    if (err) {
      console.warn("cannot set qty");
    }
    if (res) {
      const inCart = await GetCartList(controller, params);
      controller.setState({ BillingCarts: inCart });
    }
  }
};

const UpdateCarts: Handler = async (controller, params) => {
  const inCart = await GetCartList(controller, params);
  if (inCart) {
    controller.setState({ BillingCarts: inCart });
  }
};

const UpdateInvoices: Handler = async (controller, params) => {
  const invoices = await GetInvoiceList(controller, params);

  if (invoices) {
    controller.setState({ BillingInvoices: invoices });
  }
};

const GetCreditWallet: Handler = async (controller, params) => {
  let [res, err] = await MeHealthCreditWalletLatestDetailView.retrieve({
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
  });

  if (err) {
    console.warn("GetCreditWallet err: ", err);
    return;
  }

  console.log("GetCreditWallet res: ", res);
  if (res) {
    controller.setState((prevState) => {
      return {
        BillingCreditWallet: res,
        // BillingAndPackageSequence: {
        //   ...prevState.BillingAndPackageSequence,
        //   creditWallet: res
        // },
      };
    });
  }
};

const GetCreditUsageList: Handler = async (controller, params) => {
  controller.setState((prevState) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        creditUsageLoading: true,
      },
    };
  });

  // const meHealthPackageList =
  //   controller.getState()?.BillingAndPackageSequence?.meHealthPackageList?.items || [];

  const [res, err] = await MeHealthCreditWalletTransactionListView.list({
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
    params: {
      order_no: params?.credit_no || null,
      credit_use: params?.credit_use || null,
      start_date: params?.credit_date_start || null,
      end_date: params?.credit_date_end || null,
      exclude_zero_amount: true
    },
  });

  if (err) {
    console.warn("Error fetching receipts:", err);

    controller.setState((prevState) => {
      return {
        BillingAndPackageSequence: {
          ...prevState.BillingAndPackageSequence,
          creditUsageLoading: false,
          creditUsageList: null,
        },
      };
    });

    return null;
  }

  controller.setState((prevState) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        creditUsageLoading: false,
        creditUsageList: res || null,
      },
    };
  });

  console.log("GetReceiptList res: ", res);
  return res || null;
};

const GoToBillingPackage: Handler = async (controller, params) => {
  // ถ้าอยู่หน้า Billing & Package อยู่แล้ว แค่ ปิด Modal
  // แต่ถ้า อยู่หน้าอื่น ให้มา Billing & Package
  // ถ้าเป็นหน้า Broadcast ให้ปิด Modal เพื่อดำเนินการ Broadcast ต่อ
  const state = controller.getState();

  if (state.BillingAndPackageSequence?.isBroadcast) {
    controller.setState({
      BillingAndPackageSequence: {
        ...state.BillingAndPackageSequence,
        openPaidResultModal: false,
        isBroadcast: false,
      }
    });

    return;
  }

  if (state.showTabName !== ADMIN_NAME_LIST["Billing & Package"]) {
    console.log("params.tabAdminRef: ", params.tabAdminRef);
    params.tabAdminRef?.changeTabKey(ADMIN_NAME_LIST["Billing & Package"]);

    return;
  }

  controller.setState({
    BillingAndPackageSequence: {
      ...state.BillingAndPackageSequence,
      openPaidResultModal: false,
      isBroadcast: false,
    },
  });
};

const PeriodicCheck: Handler = async (controller, params) => {
  let state = controller.getState();

  if (state.BillingAndPackageSequence?.paymentCheckerPolling?.stop) {
    state.BillingAndPackageSequence?.paymentCheckerPolling.stop();
  }

  if (!state.BillingAndPackageSequence?.paymentCheckerPolling) {
    let apiToken = controller.apiToken;
    let division = `${controller.data.division || 0}`;

    const VerifiedPaidFromBackend = async (data: any) => {
      console.log("data: ", data);

      GetCreditWallet(controller, params);
      UpdateCarts(controller, params);
      UpdateInvoices(controller, params);

      controller.setState((prevState: any) => {
        return {
          BillingAndPackageSequence: {
            ...prevState.BillingAndPackageSequence,
            paymentCheckerPolling: null,
            openPaidTypePackageModal: false,
            openPaidResultModal: true,
            transactions: {
              ...prevState.BillingAndPackageSequence.transactions,
              prepareInvoice: {},
              paidResult: data,
            },
          },
        };
      });
    };

    const FailedToVerifiedPaidFromBackend = (data?: any) => {
      GetCreditWallet(controller, params);
      UpdateCarts(controller, params);
      UpdateInvoices(controller, params);

      controller.setState((prevState: any) => {
        return {
          BillingAndPackageSequence: {
            ...prevState.BillingAndPackageSequence,
            transactions: {
              ...prevState.BillingAndPackageSequence.transactions,
              prepareInvoice: {},
              ...(data && { paidResult: data }),
            },
            paymentCheckerPolling: null,
            openPaidTypePackageModal: false,
            openPaidResultModal: true,
          },
        };
      });
    };

    let checker = null;
    if (params.invoiceId) {
      checker = new PaymentStatusChecker(params.invoiceId, apiToken, division, {
        initialInterval: 5000, // Start checking every 2 seconds
        maxInterval: 30000, // Max 30 seconds between checks
        // maxAttempts: 50, // Stop after 50 attempts
        // timeout: 5 * 60 * 1000, // Stop after 5 minutes

        onComplete: (data) => {
          console.log("Payment completed:", data);
          // Redirect or show success message
          // window.location.href = "/payment/success";
          VerifiedPaidFromBackend(data);
        },

        onFailed: (data) => {
          console.log("Payment failed:", data);
          FailedToVerifiedPaidFromBackend();
        },

        onPending: (data, attempts) => {
          if (attempts === 1) {
            controller.setState((prevState: any) => {
              return {
                BillingAndPackageSequence: {
                  ...prevState.BillingAndPackageSequence,
                  transactions: {
                    ...prevState.BillingAndPackageSequence.transactions,
                    paidResult: data,
                  },
                },
              };
            });
          }
          console.log(`Payment pending... data: `, data, ` (attempt ${attempts})`);
        },

        // onTimeout: () => {
        //   console.log("Payment check timed out");
        //   failed();
        // },

        onError: (error, attempts) => {
          console.error(`Error on attempt ${attempts}:`, error);
          FailedToVerifiedPaidFromBackend();
        },

        // onMaxAttempts: () => {
        //   console.error(`Error on onMaxAttempts `);
        //   failed();
        // },
      });

      checker.start();
    }

    if (checker) {
      controller.setState((prevState: any) => {
        return {
          BillingAndPackageSequence: {
            ...prevState.BillingAndPackageSequence,
            paymentCheckerPolling: checker,
          },
        };
      });
    }
  }
};

const GetPaidChoice: Handler = async (controller, params) => {
  let [res, err] = await MeHealthPaymentMethodListView.get({
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
  });

  let [saveCreditCard, err2] = await DivisionPaymentInfoListView.list({
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
  });

  console.log("saveCreditCard: ", saveCreditCard);
  if (err) {
    console.warn("GetPaidChoice error: ", err);
    controller.setState((prevState: any) => {
      return {
        BillingAndPackageSequence: {
          ...prevState.BillingAndPackageSequence,
          paymentMethods: { items: [], total: 0, next: null, previous: null },
        },
      };
    });
  }

  if (res) {
    // console.log("res: ", res);
    controller.setState((prevState: any) => {
      let addQrCodeInItems: any[] = res.items;

      // let idx = addQrCodeInItems.findIndex((i: any) => i.type === PROMPT_PAY_TYPE);
      // console.log("idx: ", idx);
      // // TODO: Debug
      // if (idx != -1) {
      //   addQrCodeInItems[idx].qr_image_base64 =
      //     "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";
      // }
      addQrCodeInItems?.push({ type: "IMBANK" });

      return {
        BillingAndPackageSequence: {
          ...prevState.BillingAndPackageSequence,
          paymentMethods: {
            items: addQrCodeInItems || [],
            ...(saveCreditCard && { saveCreditCard: saveCreditCard }),
          },
          // paymentMethods: res
        },
      };
    });
  }
};

const frontEndDebug: Handler = async (controller, params) => {
  // !!! NEVER put real secret keys in frontend!
  // TODO://  NEVER put real secret keys in frontend!
  const secret = "6967C96CEBFAC8E162ABA87B5555650143732ECF472C6CCCCB74A1A9872285DD";

  let state = controller.getState();

  const firstNameUsage = state.userProfile?.first_name_en || state.userProfile?.first_name;
  const lastNameUsage = state.userProfile?.last_name_en || state.userProfile?.last_name;

  const payload = {
    merchantID: "764764000003870",
    invoiceNo: state.BillingAndPackageSequence?.transactions?.prepareInvoice?.id,
    description: `Total ${state.BillingAndPackageSequence?.transactions?.prepareInvoice?.items?.length}`,
    amount:
      state.BillingAndPackageSequence?.transactions?.prepareInvoice?.total_price_included_vat.replace(
        /,/g,
        ""
      ),
    currencyCode: "THB",
    tokenize: true,
    // customerToken: ["24112509345967463942"],
    // customerTokenOnly: true,
    // iframeMode: true,
    locale: "th",
    paymentChannel: [params.type],
    // frontendReturnUrl: `${window.location.origin}/?app=HIS`,
    // frontendReturnUrl: "https://mehealth-api.ishealth.app/apis/MEH/me-health-receipt",
    backendReturnUrl: "https://paymentpost-zrggczf6jq-de.a.run.app",
    uiParams: { 
      userInfo: { 
        name: `${firstNameUsage} ${lastNameUsage}`,
        email:  state.BillingAndPackageSequence?.transactions?.formData.email 
      } 
    },
  };
  console.log("payload: ", payload);

  const jwt = jwt_encode(payload, secret);
  console.log("payload jwt: ", jwt);

  const response = await fetch("https://sandbox-pgw.2c2p.com/payment/4.3/paymentToken", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ payload: jwt }),
  });

  const data = await response.json();
  console.log("data: ", data);
  const decoded = jwtDecode(data?.payload);
  console.log("decoded: ", decoded);

  controller.setState((prevState) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        open2C2PPaymentModal: true,
        webPaymentUrl: decoded?.webPaymentUrl,
      },
    };
  });
};

const Select2C2P: Handler = async (controller, params) => {
  if (false) {
    frontEndDebug(controller, { type: params.type });
  } else {
    let state = controller.getState();

    const firstNameUsage = state.userProfile?.first_name_en || state.userProfile?.first_name;
    const lastNameUsage = state.userProfile?.last_name_en || state.userProfile?.last_name;

    let pass = {
      invoiceNo: state.BillingAndPackageSequence?.transactions?.prepareInvoice?.id,
      // description: `Total ${state.BillingAndPackageSequence?.transactions?.prepareInvoice?.items?.length}` ,
      amount:
        state.BillingAndPackageSequence?.transactions?.prepareInvoice?.total_price_included_vat.replace(
          /,/g,
          ""
        ),
      paymentChannel: params.type,
      name: `${firstNameUsage} ${lastNameUsage}`,
      email: state.BillingAndPackageSequence?.transactions?.formData.email,
      ...(params.customerToken && { customerToken:  params.customerToken}),
      ...(!params.customerToken && {tokenize: true})
      // uiParams: {userInfo: {name:  , email: state.BillingAndPackageSequence?.transactions?.formData.email}}
    };
    console.log("pass: ", pass);
    let [res, err] = await MeHealthInvoicePaymentTokenView.get({
      apiToken: controller.apiToken,
      params: pass,
      extra: { division: controller.data.division || 0 },
    });

    if (err) {
      console.warn("err: ", err);
    }

    console.log("res: ", res);

    controller.setState((prevState) => {
      return {
        BillingAndPackageSequence: {
          ...prevState.BillingAndPackageSequence,
          open2C2PPaymentModal: true,
          ...( res && { webPaymentUrl: res?.webPaymentUrl}),
          paymentChannel: params.type,
          transactions: {
            ...prevState.BillingAndPackageSequence?.transactions,
            creatingInvoice: false,
          },
        },
      };
    });
  }
};

// const QrcodeSelected: Handler = async (controller, params) => {
//   console.log("QrcodeSelected params.type: ", params.type);

//   if (false) {
//     frontEndDebug(controller, { type: "QR" });
//   } else {
//     let state = controller.getState();

//     let pass = {
//       invoiceNo: state.BillingAndPackageSequence?.transactions?.prepareInvoice?.id,
//       // description: `Total ${state.BillingAndPackageSequence?.transactions?.prepareInvoice?.items?.length}` ,
//       amount:
//         state.BillingAndPackageSequence?.transactions?.prepareInvoice?.total_price_included_vat.replace(
//           /,/g,
//           ""
//         ),
//       paymentChannel: params.type,
//       uiParams: {userInfo: {name: `${state.userProfile?.first_name} ${state.userProfile?.last_name}` , email: state.BillingAndPackageSequence?.transactions?.formData.email}}
//     };
//     console.log("pass: ", pass);
//     let [res, err] = await MeHealthInvoicePaymentTokenView.get({
//       apiToken: controller.apiToken,
//       params: pass,
//       extra: { division: controller.data.division || 0 },
//     });

//     if (err) {
//       console.warn("err: ", err);
//     }

//     console.log("res: ", res);

//     controller.setState((prevState) => {
//       return {
//         BillingAndPackageSequence: {
//           ...prevState.BillingAndPackageSequence,
//           open2C2PPaymentModal: true,
//           webPaymentUrl: res?.webPaymentUrl,
//         },
//       };
//     });
//   }
// };

// const ImbankSelected: Handler = async (controller, params) => {

//   console.log("CardSelected params.type: ", params.type);

//   if (false) {
//     frontEndDebug(controller, { type: "IMBANK" });
//   } else {
//     let state = controller.getState();
//     let [res, err] = await MeHealthInvoicePaymentTokenView.get({
//       apiToken: controller.apiToken,
//       params: {
//         invoiceNo: state.BillingAndPackageSequence?.transactions?.prepareInvoice?.id,
//         // description: `Total ${state.BillingAndPackageSequence?.transactions?.prepareInvoice?.items?.length}` ,
//         amount:
//           state.BillingAndPackageSequence?.transactions?.prepareInvoice?.total_price_included_vat.replace(
//             /,/g,
//             ""
//           ),
//         paymentChannel: params.type,
//         ...(params.customerToken && { customerToken: params.customerToken }),
//         uiParams: {userInfo: {name: `${state.userProfile?.first_name} ${state.userProfile?.last_name}` , email: state.BillingAndPackageSequence?.transactions?.formData.email}}
//       },
//       extra: { division: controller.data.division || 0 },
//     });

//     if (err) {
//       console.warn("err: ", err);
//     }

//     console.log("res: ", res);

//     controller.setState((prevState) => {
//       return {
//         BillingAndPackageSequence: {
//           ...prevState.BillingAndPackageSequence,
//           open2C2PPaymentModal: true,
//           webPaymentUrl: res?.webPaymentUrl,
//         },
//       };
//     });
//   }

// }

// const CardSelected: Handler = async (controller, params) => {
//   console.log("CardSelected params.type: ", params.type);

//   if (false) {
//     frontEndDebug(controller, { type: "CC" });
//   } else {
//     let state = controller.getState();
//     let [res, err] = await MeHealthInvoicePaymentTokenView.get({
//       apiToken: controller.apiToken,
//       params: {
//         invoiceNo: state.BillingAndPackageSequence?.transactions?.prepareInvoice?.id,
//         // description: `Total ${state.BillingAndPackageSequence?.transactions?.prepareInvoice?.items?.length}` ,
//         amount:
//           state.BillingAndPackageSequence?.transactions?.prepareInvoice?.total_price_included_vat.replace(
//             /,/g,
//             ""
//           ),
//         paymentChannel: params.type,
//         ...(params.customerToken && { customerToken: params.customerToken }),
//         uiParams: {userInfo: {name: `${state.userProfile?.first_name} ${state.userProfile?.last_name}` , email: state.BillingAndPackageSequence?.transactions?.formData.email}}
//       },
//       extra: { division: controller.data.division || 0 },
//     });

//     if (err) {
//       console.warn("err: ", err);
//     }

//     console.log("res: ", res);

//     controller.setState((prevState) => {
//       return {
//         BillingAndPackageSequence: {
//           ...prevState.BillingAndPackageSequence,
//           open2C2PPaymentModal: true,
//           webPaymentUrl: res?.webPaymentUrl,
//         },
//       };
//     });
//   }
// };

const PaidPackage: Handler = async (controller, params) => {
  // if (res) {
  controller.setState((prevState: any) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        openTransactionModal: false,
        openPaidTypePackageModal: true,
        // transactions: {
        //   ...prevState.BillingAndPackageSequence?.transactions,
        //   prepareInvoice: res
        // }
      },
    };
  });
};
// }

const CreateInvoice: Handler = async (controller, params) => {
  let state = controller.getState();

  controller.setState((prevState: any) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        transactions: {
          ...prevState.BillingAndPackageSequence?.transactions,
          creatingInvoice: true,
        },
      },
    };
  });

  let items = state.BillingCarts?.items
    ?.filter((i: any) => {
      let qty = 0;
      if (typeof i.quantity === "string") {
        qty = Number(i.quantity.replace(/,/g, ""));
      } else if (typeof i.quantity === "number") {
        qty = i.quantity;
      }

      if (qty > 0) {
        return true;
      } else {
        return false;
      }
    })
    ?.map((i: any) => ({
      id: i.id,
      quantity: Number(i.quantity),
    }));

  // let divisionProfile: any = {}
  // if (state.BillingAndPackageSequence?.divisionProfile) {
  //   divisionProfile = state.BillingAndPackageSequence?.divisionProfile
  // } else {
  //   divisionProfile = await GetDivisionProfile(controller,params);
  // }

  // const fullAddress = (() => {
  //   const profile = divisionProfile;
  //   if (!profile) return "";

  //   const { business_type, branch_type, branch_name, business_name, first_name, last_name, address_text } = profile;

  //   let suffix = branch_type === "HEADQUARTER"
  //     ? "สำนักงานใหญ่"
  //     : branch_type === "BRANCH" && branch_name
  //       ? branch_name
  //       : "";

  //   let line1 = business_type === "INDIVIDUAL"
  //     ? `${first_name || ""} ${last_name || ""}`.trim()
  //     : business_name || "";

  //   if (suffix) line1 = `${line1} ${suffix}`;

  //   return `${line1}\n${address_text || ""}`.trim();
  // })();

  console.log(
    "state.BillingAndPackageSequence?.transactions:  ",
    state.BillingAndPackageSequence?.transactions
  );

  let [res, err] = await MeHealthInvoiceCreateView.create({
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
    data: {
      email: state.BillingAndPackageSequence?.transactions?.formData.email,
      tax_invoice_address: state.BillingAndPackageSequence?.transactions?.formData.address,
      taxpayer_id: state.BillingAndPackageSequence?.transactions?.formData.taxId,
      items,
    },
  });

  if (err) {
    console.warn("Cannot create invoice", err);
    controller.setState((prevState: any) => {
      return {
        BillingAndPackageSequence: {
          ...prevState.BillingAndPackageSequence,
          transactions: {
            ...prevState.BillingAndPackageSequence?.transactions,
            // creatingInvoice: false,
          },
        },
      };
    });
    return;
  }

  if (res) {
    controller.setState((prevState: any) => {
      return {
        BillingAndPackageSequence: {
          ...prevState.BillingAndPackageSequence,
          openTransactionModal: false,
          openPaidTypePackageModal: true,
          transactions: {
            ...prevState.BillingAndPackageSequence?.transactions,
            prepareInvoice: res,
            // creatingInvoice: false,
          },
        },
      };
    });
  } 
};

const UseExistingInvoice: Handler = async (controller, params) => {
  const state = controller.getState();

  const existingInvoice = state.BillingAndPackageSequence?.transactions?.prepareInvoice;

  if (!existingInvoice) {
    console.warn("Existing Invoice doens't exist!!");
    return;
  }

  controller.setState((prevState: State) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        openTransactionModal: false,
        openPaidTypePackageModal: true,
        transactions: {
          ...prevState.BillingAndPackageSequence?.transactions,
          prepareInvoice: existingInvoice,
        },
      },
    };
  });
};

const BackToTransactionSummary: Handler = async (controller, params) => {
  controller.setState((prevState: any) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        openTransactionModal: true,
        openPaidTypePackageModal: false,
      },
    };
  });
};

const AddToCard: Handler = async (controller, params) => {
  controller.setState((prevState: any) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        addToCartLoading: true,
      },
    };
  });

  let data = {
    items: [
      {
        id: params.id,
        quantity: params.quantity,
      },
    ],
  };

  let packageSelected: any = ( controller.getState()?.BillingAndPackageSequence?.meHealthPackageList?.items || [])?.find((p: any) => p.id == params.id);
  let price: number = packageSelected?.price || 0;

  const [res, err] = await MeHealthPackageAddToCartView.post({
    data,
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
  });

  if (err) {
    console.warn(err);
    let message = "ไม่สามารถทำรายการได้";

    if (err.package && Array.isArray(err.package) && err.package.length > 0) {
      message = err.package[0];
    }

    controller.setState((prevState: any) => ({
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        addToCartLoading: false,
        addToCartError: message,
      },
    }));

    return { ok: false, error: message };
  }

  let inCart = {};
  if (res) {

    // Prepare ecommerce bundle
    const addToCartParams = {
      currency: 'THB',
      value: price,
      items: (data?.items|| []).map((i: any) => ({
        item_id: i.id, 
        item_name: packageSelected?.name, 
        quantity: i.quantity
      }))
    };

    if (controller.analytics) {
      logEvent(controller.analytics, "add_to_cart", addToCartParams)
    }

    // Add Success
    inCart = await GetCartList(controller, params);
  }

  // console.log("res: ", res);

  controller.setState((prevState: any) => {
    return {
      BillingCarts: inCart,
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        addToCartLoading: false,
      },
    };
  });
  return { ok: true };
};

const GetPackageList: Handler = async (controller, params) => {
  const [res, err] = await MeHealthPackageListView.list({
    apiToken: controller.apiToken,
    params: { active_flag: "ACTIVE", exclude_expired: true },
    extra: { division: controller.data.division || 0 },
  });
  
  if (err) {
    console.warn(err);

    return null;
  }

  return res;
};

const GetCartList: Handler = async (controller, params) => {
  const [res, err] = await MeHealthInvoiceItemListView.list({
    apiToken: controller.apiToken,
    params: { has_invoice: false, status: "BILLED" },
    extra: { division: controller.data.division || 0 },
  });

  if (err) {
    console.warn(err);
  }

  return res;
};

const GetInvoiceList: Handler = async (controller, params) => {
  const [res, err] = await MeHealthInvoiceCreateView.list({
    apiToken: controller.apiToken,
    params: { 
      status: "BILLED",
      search_by_created_user: true,
      limit: 99999
    }, // todo --- ทำเคส Pagination แทน limit ในอนาคต
    extra: { division: controller.data.division || 0 },
  });

  if (err) {
    console.warn(err);
    return null;
  }

  return res;
};

// const UpdateCartItem: Handler = async (controller, params) => {
//   const cartItems = await GetCartItems(controller, params);

//   console.log("cartItems: ", cartItems);

//   controller.setState((prevState: any) => {
//     return {
//       BillingAndPackageSequence: {
//         ...prevState.BillingAndPackageSequence,
//         getCartItemsLoading: false,
//         cartItems,
//       },
//     };
//   });
// };

export const GetReceiptList: Handler = async (controller, params) => {
  controller.setState((prevState) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        paymentHistoryLoading: true,
      },
    };
  });

  let payoutDateStart = params?.payout_date_start;
  let payoutDateEnd = params?.payout_date_end;

  if (!payoutDateStart || !payoutDateEnd) {
    const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");

    payoutDateStart = payoutDateStart || startOfMonth;
    payoutDateEnd = payoutDateEnd || endOfMonth;
  }

  const meHealthPackageList =
    controller.getState()?.BillingAndPackageSequence?.meHealthPackageList?.items || [];

  let packageId: number | null = null;
  if (params?.package) {
    const matchedPackage = meHealthPackageList.find((pkg: any) => pkg.name === params.package);
    packageId = matchedPackage ? matchedPackage.id : null;
  }
  const queryParams = {
    order_no: params?.order_no || null,
    package: packageId || null,
    payout_date_start: payoutDateStart,
    payout_date_end: payoutDateEnd,
  };

  const extraParams = {
    division: controller.data.division || 0,
  };

  const [res, err] = await MeHealthReceiptCreateView.list({
    apiToken: controller.apiToken,
    params: queryParams,
    extra: extraParams,
  });

  if (err) {
    console.warn("Error fetching receipts:", err);
    return null;
  }

  controller.setState((prevState) => {
    return {
      BillingAndPackageSequence: {
        ...prevState.BillingAndPackageSequence,
        paymentHistoryLoading: false,
        paymentHistory: res || null,
      },
    };
  });

  console.log("GetReceiptList res: ", res);
  return res || null;
};

export const GetInvoiceDetail: Handler = async (controller, params) => {
  if (!params?.pk) {
    console.warn("Invoice ID (pk) is required.");
    return null;
  }

  const [res, err] = await MeHealthInvoiceDetailView.retrieve({
    pk: params.pk,
    apiToken: controller.apiToken,
    extra: { division: controller.data.division || 0 },
  });

  if (err) {
    console.warn("Error fetching invoice detail:", err);
    return null;
  }

  return res || null;
};

export const HandlePackageReceiptFile: Handler = async (controller, params) => {
  const receipt = params.receipt;
  if (!receipt) {
    console.warn("No receipt provided.");
    return;
  }

  const invoiceId = receipt.invoice;

  const invoice = await GetInvoiceDetail(controller, { pk: invoiceId });
  if (!invoice) {
    console.warn("Invoice not found for ID:", invoiceId);
    return;
  }

  const items = (invoice.items || []).map((inv: any, index: number) => {
    const pkg = inv.package;
    const priceNum = Number(pkg?.price?.replace(/,/g, "") || 0);
    const creditNum = Number(pkg?.credit_amount?.replace(/,/g, "") || 0);
    const qty = Number(inv.quantity || 1);

    return {
      no: index + 1,
      description: `${
        pkg?.name || "Package"
      } (${priceNum.toLocaleString()} บาท ได้รับ ${creditNum.toLocaleString()} Credit)`,
      qty,
      unit_price: priceNum,
      price: Number(inv.price?.replace(/,/g, "") || 0),
    };
  });

  const receiptNo = receipt.code || `RCPT-${Date.now()}`;

  const formatDateLong = (iso?: string) => {
    if (!iso) return "-";
    const d = new Date(iso);
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });
  };
  const receiptDate = formatDateLong(receipt.created_at);

  const formatDateTimeWithHour = (iso?: string) => {
    if (!iso) return "-";
    const d = new Date(iso);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");
    return `${dd}/${mm}/${yyyy} [${hh}:${min}]`;
  };

  const createdAtDisplay = formatDateTimeWithHour(receipt.created_at);

  const splitAddressByWords = (address: string, maxLength = 200) => {
    const words = address.split(/\s+/);
    const lines: string[] = [];
    let currentLine = "";

    for (const word of words) {
      if ((currentLine + " " + word).trim().length > maxLength) {
        lines.push(currentLine.trim());
        currentLine = word;
      } else {
        currentLine += " " + word;
      }
    }
    if (currentLine.trim()) lines.push(currentLine.trim());
    return lines;
  };

  const formatThaiTaxId = (taxId: string) => {
    if (!taxId) return "x xxxx xxxxx xx x";
    const digits = taxId.replace(/\D/g, "");
    if (digits.length !== 13) return taxId;
    return `${digits[0]} ${digits.slice(1, 5)} ${digits.slice(5, 10)} ${digits.slice(
      10,
      12
    )} ${digits.slice(12)}`;
  };

  const pdfMake = await getPdfMake(true);

  const docDefinition = await FormPackageReceipt({
    receipt_no: receiptNo,
    date: receiptDate,
    buyer_tax_id: formatThaiTaxId(invoice.taxpayer_id || params.taxpayer_id || ""),
    buyer_address_lines: splitAddressByWords(
      invoice.tax_invoice_address || params.tax_invoice_address || "",
      200
    ),
    items,
    total_price_num: invoice.total_price,
    vat: invoice.total_price_vat,
    total_incl_vat: invoice.total_price_included_vat,
    total_price_text: invoice.total_price_text,
    order_created_at: createdAtDisplay,
  });

  pdfMake.createPdf(docDefinition).download(`Receipt_${receiptNo}`);
};
